import { Controller } from "@hotwired/stimulus";
import { dataTableFunctions } from "../../datatables/datatable_functions";
import { dispatchFilterSelectedEvent } from "../../datatables/datatable_filters";
import { createBottomPopperElement, deletePopperElement } from "../../utils/popper_utils";

// This controller handles the filters selection menu.
// It allows any user to add a new filter to the selected filters,
// and adapt the menu given the selected filters.
export default class extends Controller {
  static targets = ["addFilterBtn", "menu", "menuItem"];

  connect() {
    document.addEventListener("datatable:filterPreselected", this.onFilterPreselected);

    document.addEventListener("datatable:filterUpdated", this.onFilterUpdated);

    document.addEventListener("datatable:filterCleared", this.onFilterCleared);

    this.menuPopperElement = createBottomPopperElement(this.addFilterBtnTarget, this.menuTarget);
  }

  disconnect() {
    document.removeEventListener("datatable:filterPreselected", this.onFilterPreselected);
    document.removeEventListener("datatable:filterUpdated", this.onFilterUpdated);
    document.removeEventListener("datatable:filterCleared", this.onFilterCleared);

    deletePopperElement(this.menuPopperElement);
  }

  openMenu() {
    this.menuPopperElement.scheduleUpdate();
  }

  onFilterPreselected = (event) => {
    this.filterPreselected(event);
  };

  onFilterUpdated = () => {
    this.filterUpdated();
  };

  onFilterCleared = (event) => {
    const { datatableId } = this.element.dataset;

    if (event.detail.id === datatableId) {
      this.filterCleared(event);
    }
  };

  filterPreselected(event) {
    this._hideSelectedFilter(event.detail.name);
  }

  filterSelected(event) {
    const { filterName } = event.target.dataset;

    this._hideSelectedFilter(filterName);
    this.addFilterBtnTarget.classList.remove("active");
    dispatchFilterSelectedEvent({ name: filterName });
  }

  filterUpdated() {
    const { datatableId } = this.element.dataset;
    dataTableFunctions().reloadTable(datatableId);
  }

  filterCleared(event) {
    const { name } = event.detail;
    this.menuItemTargets.find((menu) => menu.dataset.filterName === name).classList.remove("hidden");
  }

  _hideSelectedFilter(name) {
    const activeMenuItem = this.menuItemTargets.find((menu) => menu.dataset.filterName === name);
    activeMenuItem.classList.add("hidden");
  }
}
